export const clubs = state => {
    return state.clubs;
}

export const clubSessionsDetails = state => {
    return state.clubSessionsDetails;
}